import { checkIsStringEmpty } from "repoV2/utils/common/dataTypes/string";
import { checkIsValidURL } from "repoV2/utils/urls&routing/urls";
import { checkIsArrayEmpty } from "repoV2/utils/common/dataTypes/array";
import { ICustomQuestionTypes } from "../interfaces/CustomQuestionTypes.interfaces";

export const CUSTOM_QUESTION_TYPES_ID = {
    PARAGRAPH_TEXT: 1,
    SINGLE_OPTION_SELECT: 2,
    MULTI_OPTION_SELECT: 3,
    CALENDAR: 4,
    FILE: 5,
    /**
    Backend uses same enum for all custom questions(pre booking, post booking, express interest, recorded content exam).
    But following are not used in pre booking, post booking, express interest custom questions.
    Keeping it here so that it does not cause confusion in future.

    FIVE_STAR_RATING: 6,
    FIVE_NUMBER_RATING: 7,
    TEN_STAR_RATING: 8,    
     */
    SHORT_TEXT: 9,
    NUMBER: 10,
    URL: 11,
    GENDER: 12,
    INDIAN_STATE: 13,
    INDIAN_CITY: 14,
} as const;

export const other_dropdown_option = {
    id: "other_option",
    label: "Other",
    value: "--other--Other",
    selectedLabel: "Other",
};

export const CUSTOM_QUESTION_TYPES: ICustomQuestionTypes = {
    [CUSTOM_QUESTION_TYPES_ID.PARAGRAPH_TEXT]: {
        type: CUSTOM_QUESTION_TYPES_ID.PARAGRAPH_TEXT,
        defaultAnswerValue: "",
        validator:
            ({ isRequired }: { isRequired: boolean }) =>
            (value: string) => {
                const _value = (value && value.trim()) || "";
                if (isRequired) {
                    return checkIsStringEmpty(_value) ? "Required" : true;
                }
                return true;
            },
    },
    [CUSTOM_QUESTION_TYPES_ID.SHORT_TEXT]: {
        type: CUSTOM_QUESTION_TYPES_ID.SHORT_TEXT,
        defaultAnswerValue: "",
        validator:
            ({ isRequired }: { isRequired: boolean }) =>
            (value: string) => {
                const _value = (value && value.trim()) || "";
                if (isRequired) {
                    return checkIsStringEmpty(_value) ? "Required" : true;
                }
                return true;
            },
    },
    [CUSTOM_QUESTION_TYPES_ID.INDIAN_STATE]: {
        type: CUSTOM_QUESTION_TYPES_ID.INDIAN_STATE,
        defaultAnswerValue: "",
        validator:
            ({ isRequired }: { isRequired: boolean }) =>
            (value: string) => {
                const _value = (value && value.trim()) || "";
                if (isRequired) {
                    return checkIsStringEmpty(_value) ? "Required" : true;
                }
                return true;
            },
    },
    [CUSTOM_QUESTION_TYPES_ID.INDIAN_CITY]: {
        type: CUSTOM_QUESTION_TYPES_ID.INDIAN_CITY,
        defaultAnswerValue: "",
        validator:
            ({ isRequired }: { isRequired: boolean }) =>
            (value: string) => {
                const _value = (value && value.trim()) || "";
                if (isRequired) {
                    return checkIsStringEmpty(_value) ? "Required" : true;
                }
                return true;
            },
    },
    [CUSTOM_QUESTION_TYPES_ID.GENDER]: {
        type: CUSTOM_QUESTION_TYPES_ID.GENDER,
        defaultAnswerValue: "",
        validator:
            ({ isRequired }: { isRequired: boolean }) =>
            (value: string) => {
                const _value = (value && value.trim()) || "";
                if (isRequired) {
                    return checkIsStringEmpty(_value) ? "Required" : true;
                }
                return true;
            },
    },
    [CUSTOM_QUESTION_TYPES_ID.NUMBER]: {
        type: CUSTOM_QUESTION_TYPES_ID.NUMBER,
        defaultAnswerValue: "",
        validator:
            ({ isRequired, min = 0, max = 0 }) =>
            (value: string) => {
                const _value = value || "";
                if (isRequired) {
                    if (checkIsStringEmpty(_value)) {
                        return "Required";
                    }
                    if (min > 0 && max > 0 && (+value < min || +value > max)) {
                        return `Number must be between ${min} and ${max}`;
                    }
                }
                return true;
            },
    },
    [CUSTOM_QUESTION_TYPES_ID.SINGLE_OPTION_SELECT]: {
        type: CUSTOM_QUESTION_TYPES_ID.SINGLE_OPTION_SELECT,
        defaultAnswerValue: "",
        validator:
            ({ isRequired }: { isRequired: boolean }) =>
            (value: string) => {
                const _value = (value && value.trim()) || "";
                if (isRequired) {
                    return checkIsStringEmpty(_value) ? "Required" : true;
                }
                return true;
            },
    },
    [CUSTOM_QUESTION_TYPES_ID.URL]: {
        type: CUSTOM_QUESTION_TYPES_ID.URL,
        defaultAnswerValue: "",
        validator:
            ({ isRequired }: { isRequired: boolean }) =>
            (value: string) => {
                const _value = (value && value.trim()) || "";
                if (isRequired && checkIsStringEmpty(_value)) {
                    return "Required";
                }
                if (_value && !checkIsValidURL(_value)) {
                    return "Invalid Url";
                }
                return true;
            },
    },
    [CUSTOM_QUESTION_TYPES_ID.MULTI_OPTION_SELECT]: {
        type: CUSTOM_QUESTION_TYPES_ID.MULTI_OPTION_SELECT,
        defaultAnswerValue: "",
        validator:
            ({ isRequired }: { isRequired: boolean }) =>
            (value: string[]) => {
                const _value = Array.isArray(value) ? value : [];
                if (isRequired) {
                    return checkIsArrayEmpty(_value) ? "Required" : true;
                }
                return true;
            },
    },
    [CUSTOM_QUESTION_TYPES_ID.CALENDAR]: {
        type: CUSTOM_QUESTION_TYPES_ID.CALENDAR,
        defaultAnswerValue: "",
        validator:
            ({ isRequired }: { isRequired: boolean }) =>
            (value: Date) => {
                const _value = value?.toISOString() || "";
                if (isRequired) {
                    return checkIsStringEmpty(_value) ? "Required" : true;
                }
                return true;
            },
    },
    [CUSTOM_QUESTION_TYPES_ID.FILE]: {
        type: CUSTOM_QUESTION_TYPES_ID.FILE,
        defaultAnswerValue: "",
        validator:
            ({ isRequired }: { isRequired: boolean }) =>
            (value: { length: number }) => {
                if (isRequired) {
                    return value?.length ? true : "Required";
                }
                return true;
            },
    },
};
